/* global $ */
export default [
  '$timeout',
  '$compile',
  'contentTemplatesService',
  '$rootScope',
  'storyService',
  directive,
]

export const accumulateHeight = (el, height = 0) => {
  if (el.offsetParent) {
    return accumulateHeight(el.offsetParent, el.offsetTop + height)
  } else {
    return height + el.offsetTop
  }
}

export const getForceHeight = (index = -1, e = {}, contentElements = []) => {
  let forceHeight
  const { _id } = contentElements[index].additional_properties
  const comment = [...$('content-comment')].find((el) => {
    const id = el.getAttribute('data-comment-id')
    return id.toString() === _id.toString()
  })
  if (comment) {
    const contentElem = $('[content-element]')[index]
    // position of comment relative
    const boundTop = comment.getBoundingClientRect()
    const top = boundTop < 0 ? 0 : boundTop.top
    // position of clicked content element
    const boundY = contentElem.getBoundingClientRect() // accumulateHeight(contentElem)
    const y = boundY < 0 ? 0 : boundY.top
    // current margin top force height
    const pivotEl = $('#content-comment-pivot')[0]
    const currentMarginTop = pivotEl.style['margin-top']
    const marginParsed = currentMarginTop.split('px').shift()
    const curr = parseInt(marginParsed, 10) || 0
    forceHeight = y - top + curr
  }
  return forceHeight
}

function directive(
  $timeout,
  $compile,
  contentTemplatesService,
  $rootScope,
  storyService
) {
  return {
    replace: false,
    require: '?ngModel',
    restrict: 'AE',
    scope: {
      storyid: '=',
      feature: '=',
      index: '=',
      showPropModal: '=',
    },
    controller: [
      'storyService',
      '$scope',
      '$rootScope',
      '$timeout',
      function(storyService, $scope, $rootScope, $timeout) {
        $scope.currentFocus = 0
        $scope.commentClick = (index, e) => {
          const {
            content_elements: contentElements,
          } = storyService.getStorySync()
          // in order to tether a specific comment to the
          // corresponding coordinate of a content element,
          // we have to move the entire "pivot" container
          // which houses *all* the comments
          const baseParams = {
            type: 'COMMENT_FOCUS',
            index,
            _id: contentElements[index].additional_properties._id,
            forceHeight: getForceHeight(index, e, contentElements),
          }
          const params = {
            ...baseParams,
            callback: () => {
              $timeout(() => {
                $rootScope.$broadcast('CONTENT_COMMENT', {
                  ...baseParams,
                  ignore: true,
                  forceHeight: getForceHeight(index, e, contentElements),
                })
              }, 50)
            },
          }
          $rootScope.$broadcast('CONTENT_COMMENT', params)
        }
      },
    ],
    link: {
      pre: function($scope, element, attrs, ngModel) {
        $scope.type = attrs.type
        $scope.orgIndex = parseInt(attrs.orgIndex, 10)
        // each content element in array has a type property
        // content template service has templates specified by that type
        // for the case of services timing out and an "incorrect" type being returned,
        // check here for that discrepency and setup a guard
        let template
        if ($scope.feature.type === 'reference') {
          if ($scope.feature.referent) {
            // type mismatch, send "error" content element
            if (
              $scope.feature.referent.type &&
              $scope.feature.referent.type !== $scope.feature.type
            ) {
              template = contentTemplatesService.getTemplate('loadFailure')
            } else if ($scope.feature.referent.service === 'oembed') {
              // edge case for empty social embed, it has no referent.type apparently
              template = contentTemplatesService.getTemplate(attrs.type) // .replace(/^(<[^\s>]+)([>\s])/,'$1 ng-xxmodel="' + attrs.ngModel + '"$2')
            }
          }
        } else {
          template = contentTemplatesService.getTemplate(attrs.type) // .replace(/^(<[^\s>]+)([>\s])/,'$1 ng-xxmodel="' + attrs.ngModel + '"$2');
        }

        template =
          typeof template === 'function'
            ? template({ index: $scope.index })
            : template

        element.append($compile(template)($scope))
      },
      post: function($scope, element, attrs, ngModel) {
        const editable = element.find('[contenteditable]')[0]
        const input = element.find('input')[0]
        const textarea = element.find('textarea')[0]
        const li = element.find('li')[0]

        // TODO: let elem = input || textarea || editable || li || element;
        let elem = element
        if (input) {
          elem = input
        } else if (textarea) {
          elem = textarea
        } else if (editable) {
          elem = editable
        } else if (li) {
          elem = li
        }

        element.on('focus', (e) => {
          const n = parseInt(attrs.orgIndex, 10)
          $timeout(() => {
            $scope.commentClick(n, e)
          }, 1)
        })

        const unsubscribe = $rootScope.$on('COMPOSE_NAV', (meta, { index }) => {
          if ($scope.orgIndex === index) {
            elem.focus()
          }
        })
        $scope.$on('$destroy', () => {
          unsubscribe()
        })
      },
    },
  }
}
